import script from "./Activity_Goodkidtest_20260508.vue?vue&type=script&setup=true&lang=js"
export * from "./Activity_Goodkidtest_20260508.vue?vue&type=script&setup=true&lang=js"

import "./Activity_Goodkidtest_20260508.vue?vue&type=style&index=0&id=27a4e532&lang=less&scoped=true"
import "./Activity_Goodkidtest_20260508.vue?vue&type=style&index=1&id=27a4e532&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27a4e532"]])

export default __exports__